import { render, staticRenderFns } from "./configImg.vue?vue&type=template&id=19fdc606&scoped=true&"
import script from "./configImg.vue?vue&type=script&lang=js&"
export * from "./configImg.vue?vue&type=script&lang=js&"
import style0 from "./configImg.vue?vue&type=style&index=0&id=19fdc606&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fdc606",
  null
  
)

export default component.exports